export default __webpack_public_path__ + "static/media/health_checks.ad5fcea9.svg";